"use client";

import styles from "./pricing-page.module.scss";
import SubtypeButton, {
  SubType,
} from "@/components/pages/pricing-a/components/subtype-button";
import { SubscriptionInfo } from "@/data/license.data";
import React from "react";
import PricingFeatures from "@/components/pages/pricing-a/components/pricing-features/pricing-features";
import FaqItems from "@/components/pages/faq/components/faq-items";
import { pricingFaqData } from "@/data/faq.data";
import StatsCount from "@/components/pages/pricing-a/components/stats-count";
import ReferFriend from "@/components/pages/pricing-a/components/refer-friend";
import Pricing from "@/components/common/pricing";
import { useABTestPricePageContext } from "@/providers/ab-testing-providers/ab-test-pricing-page-provider";

const PricingPage_A = () => {
  const { trackABConversion } = useABTestPricePageContext();

  const trackConversion = (
    isYearly: boolean,
    subscriptionInfo: SubscriptionInfo,
  ) => {
    const type = isYearly ? "year" : "month";
    const name = subscriptionInfo.title.toLowerCase();
    trackABConversion(`${type}-${name}`);
  };
  const scrollToFeatures = () => {
    const element = document.getElementById("features");
    element?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  return (
    <div className={styles.pricing}>
      <h1>
        Plans <span>&</span> Pricing
      </h1>
      <StatsCount />
      <Pricing
        handleAllFeaturesClick={scrollToFeatures}
        onUpgradeClick={trackConversion}
      />
      <ReferFriend />
      <div id={"features"}>
        <PricingFeatures />
      </div>
      <FaqItems faqData={pricingFaqData} />
    </div>
  );
};

const selectedTabFactory = (tab: string | null): SubType => {
  switch (tab) {
    case "month":
      return "MONTHLY";
    case "year":
      return "YEARLY";
    default:
      return "YEARLY";
  }
};

export default PricingPage_A;
